module.exports = __webpack_public_path__ + "img/ideaengineering.f9cb6296.png";